<div class="container mt-4" style="min-height: calc(100vh - 300px);">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class=" card-header">
          <h5 class="font-medium election-title">📄 Misappropriation/Embezzlement Cases </h5>
        </div>
        <div class="card-body">
          <div class="row align-items-end">
            <!-- <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Block Office<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Financial/Reporting Year<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-6 text-end">
                            <button type="button" class="btn btn-primary">Get Report</button>
                        </div> -->

            <form [formGroup]="targetForm" (ngSubmit)="GetMisappropriation()">
              <div class="row align-items-end">
                                       <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                  <option value="">--Select--</option>
                  <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                    {{ circle?.sCircleName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                  class="text-danger small">
                  Circle office is required
                </div>
              </div>

                <!-- Block Office -->
                <div class="col-lg-4 col-md-6 mb-2">
                  <label class="form-label">Block Office <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="blockOffice">
                    <option value="" selected>--Select--</option>
                    <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                      {{ circle?.sBlockName }}
                    </option>
                  </select>
                  <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                    class="text-danger small">
                    block Office is required
                  </div>
                </div>

                <!-- Financial Year -->
                <div class="col-lg-4 col-md-6 mb-2">
                  <label class="form-label">Financial/Reporting Year <span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="financialYear">
                    <option value="">--Select--</option>
                    <option *ngFor="let years of financialYears" [ngValue]="years">
                      {{ years?.financialYear }}
                    </option>
                  </select>
                  <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                    class="text-danger small">
                    Financial year is required
                  </div>
                </div>

                <!-- Submit -->
                <div class="col-lg-12 text-end">
                  <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                    Get Report
                  </button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <div class=" card-header">
          <div class="d-flex align-items-center justify-content-between gap-1">
            <h5 class="font-medium m-0">📄 Reports</h5>
            <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal"
              data-bs-target="#MisappropriationEmbezzlementCasesModal" (click)="addData()"
              *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">Add Data for
              {{currentMonth?.name}}</button>
            <!-- Modal -->
            <div class="modal fade" id="MisappropriationEmbezzlementCasesModal" data-bs-backdrop="static"
              data-bs-keyboard="false" tabindex="-1" aria-labelledby="MisappropriationEmbezzlementCasesModalLabel"
              aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                <div class="modal-content">
                  <div class="modal-header">
                    <h1 class="modal-title fs-5" id="MisappropriationEmbezzlementCasesModalLabel">
                      Add Misappropriation/Embezzlement Cases Data</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                      (click)="closeModel()"></button>
                  </div>
                  <div class="modal-body">

                    <form [formGroup]="caseForm">
                      <div class="row">
                        <!-- Financial Year -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label">Financial/Reporting Year <span class="text-danger">*</span></label>
                          <select class="form-control" formControlName="financialYear">
                            <option value="">--Select--</option>
                            <option *ngFor="let years of financialYears" [ngValue]="years">
                              {{ years?.financialYear }}
                            </option>
                          </select>
                          <div *ngIf="caseForm.get('financialYear')?.touched && caseForm.get('financialYear')?.invalid"
                            class="text-danger small">
                            Financial year is required
                          </div>
                        </div>


                        <!-- Block Office -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label">Block Office <span class="text-danger">*</span></label>
                          <select class="form-control" formControlName="blockOffice">
                            <option value="" selected>--Select--</option>
                            <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                              {{ circle?.sBlockName }}
                            </option>
                          </select>
                          <div *ngIf="caseForm.get('blockOffice')?.touched && caseForm.get('blockOffice')?.invalid"
                            class="text-danger small">
                            block Office is required
                          </div>
                        </div>


                        <!-- During Month -->
                        <div class="col-lg-4 col-md-6 mb-2">
                          <label class="form-label">During Month <span class="text-danger">*</span></label>
                          <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                          <select class="form-control" formControlName="dataMonth">
                            <option value="" selected>--Select Month--</option>
                            <option *ngFor="let month of months" [value]="month?.iMonthId">
                              {{ month?.sMonthName }}
                            </option>
                          </select>

                          <div class="text-danger small" style="min-height: 1.25rem;">
                            <span *ngIf="caseForm.get('dataMonth')?.touched && caseForm.get('dataMonth')?.invalid">
                              This field is required
                            </span>
                          </div>
                        </div>

                        <!-- Table Section -->
                        <div class="col-lg-12">
                          <label class="form-label">Cases Details<sup class="text-danger">*</sup></label>

                          <div class="table-responsive" formArrayName="cases">
                            <table class="table table-bordered table-hover">
                              <thead>
                                <tr class="texture font-size-12">
                                  <th rowspan="2" style="width:2%">S. N.</th>
                                  <th rowspan="2" style="width:2%">Item Name</th>
                                  <th class="text-center" colspan="2">Pending Cases as on 01 {{currentMonth?.name}}</th>
                                  <th class="text-center" colspan="2">Fresh Cases during {{currentMonth?.name}}</th>
                                  <th class="text-center" colspan="2">Cases Decided during {{currentMonth?.name}}</th>
                                </tr>
                                <tr class="texture font-size-12">
                                  <th style="width: 8%">No.</th>
                                  <th style="width: 18%">Amt (<i class="fa fa-inr fa-mr-0"></i>)</th>
                                  <th style="width: 8%">No.</th>
                                  <th style="width: 22%">Amt (<i class="fa fa-inr fa-mr-0"></i>)</th>
                                  <th style="width: 8%">No.</th>
                                  <th style="width: 22%">Amt (<i class="fa fa-inr fa-mr-0"></i>)</th>
                                </tr>
                              </thead>
                              <!-- 
                              <tbody>
                                <tr *ngFor="let group of cases.controls; let i = index" [formGroupName]="i">
                                  <td>{{ i + 1 }}</td>
                                  <td>
                                    <input type="text" class="form-control" formControlName="itemName" readonly />
                                  </td>

                                 -- Pending 
                                  <td>
                                    <input type="text" class="form-control" style="width:80px;"
                                      formControlName="pendingCount" />
                                  </td>
                                  <td>
                                    <input type="text" class="form-control" formControlName="pendingAmount" />
                                  </td>

                                  -- Fresh --
                                  <td>
                                    <input type="text" class="form-control" style="width:80px;" (input)="allowOnlyInteger($event, 5)"
                                      formControlName="freshCount" />
                                    <div class="text-danger small"
                                      *ngIf="group.get('freshCount')?.touched && group.get('freshCount')?.invalid">
                                      Enter valid count
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-group">
                                      <span class="input-group-text">₹</span>
                                      <input type="text" class="form-control" formControlName="freshAmount"   (input)="allowAmount($event, 10)"/>
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('freshAmount')?.touched && group.get('freshAmount')?.invalid">
                                      Enter valid amount
                                    </div>
                                  </td>

                                  -- Decided --
                                  <td>
                                    <input type="text" class="form-control" style="width:80px;"
                                      formControlName="decidedCount" (input)="allowOnlyInteger($event, 5)" />
                                    <div class="text-danger small"
                                      *ngIf="group.get('decidedCount')?.touched && group.get('decidedCount')?.invalid">
                                      Enter valid count
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-group">
                                      <span class="input-group-text">₹</span>
                                      <input type="text" class="form-control" formControlName="decidedAmount"  (input)="allowAmount($event, 10)" />
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('decidedAmount')?.touched && group.get('decidedAmount')?.invalid">
                                      Enter valid amount
                                    </div>
                                  </td>
                                </tr>
                              </tbody> -->
                              <tbody>
                                <tr *ngFor="let group of cases.controls; let i = index" [formGroupName]="i">
                                  <td>{{ i + 1 }}</td>
                                  <td>
                                    <input type="text" class="form-control" formControlName="itemName" readonly />
                                  </td>

                                  <!-- Pending -->
                                  <!-- <td>
                                    <input type="text" class="form-control" style="width:80px;"
                                      formControlName="pendingCount" />
                                  </td>
                                  <td>
                                    <input type="text" class="form-control" formControlName="pendingAmount" />
                                  </td> -->
                                  <td>
                                    <input type="text" class="form-control" style="width:80px;"
                                      placeholder="Enter count" (input)="allowOnlyInteger($event, 5)"
                                      formControlName="pendingCount" />
                                    <div class="text-danger small"
                                      *ngIf="group.get('pendingCount')?.touched && group.get('pendingCount')?.invalid">
                                      Enter valid count
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('pendingCount')?.value?.toString()?.length >= 5">
                                      Maximum 5 digits allowed
                                    </div>
                                  </td>

                                  <td>
                                    <div class="input-group">
                                      <span class="input-group-text">₹</span>
                                      <input type="text" class="form-control" formControlName="pendingAmount"
                                        placeholder="Enter amount" (input)="allowAmount($event, 10)" />
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('pendingAmount')?.touched && group.get('pendingAmount')?.invalid">
                                      Enter valid amount
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('pendingAmount')?.value?.toString()?.length >= 10">
                                      Maximum 10 digits allowed
                                    </div>
                                  </td>
                                  <!-- Fresh -->
                                  <td>
                                    <input type="text" class="form-control" style="width:80px;"
                                      placeholder="Enter count" (input)="allowOnlyInteger($event, 5)"
                                      formControlName="freshCount" />
                                    <div class="text-danger small"
                                      *ngIf="group.get('freshCount')?.touched && group.get('freshCount')?.invalid">
                                      Enter valid count
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('freshCount')?.value?.toString()?.length >= 5">
                                      Maximum 5 digits allowed
                                    </div>
                                  </td>

                                  <td>
                                    <div class="input-group">
                                      <span class="input-group-text">₹</span>
                                      <input type="text" class="form-control" formControlName="freshAmount"
                                        placeholder="Enter amount" (input)="allowAmount($event, 10)" />
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('freshAmount')?.touched && group.get('freshAmount')?.invalid">
                                      Enter valid amount
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('freshAmount')?.value?.toString()?.length >= 10">
                                      Maximum 10 digits allowed
                                    </div>
                                  </td>

                                  <!-- Decided -->
                                  <td>
                                    <input type="text" class="form-control" style="width:80px;"
                                      placeholder="Enter count" formControlName="decidedCount"
                                      (input)="allowOnlyInteger($event, 5)" />
                                    <div class="text-danger small"
                                      *ngIf="group.get('decidedCount')?.touched && group.get('decidedCount')?.invalid">
                                      Enter valid count
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('decidedCount')?.value?.toString()?.length >= 5">
                                      Maximum 5 digits allowed
                                    </div>
                                  </td>

                                  <td>
                                    <div class="input-group">
                                      <span class="input-group-text">₹</span>
                                      <input type="text" class="form-control" formControlName="decidedAmount"
                                        placeholder="Enter amount" (input)="allowAmount($event, 10)" />
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('decidedAmount')?.touched && group.get('decidedAmount')?.invalid">
                                      Enter valid amount
                                    </div>
                                    <div class="text-danger small"
                                      *ngIf="group.get('decidedAmount')?.value?.toString()?.length >= 10">
                                      Maximum 10 digits allowed
                                    </div>
                                  </td>
                                </tr>
                              </tbody>

                            </table>
                          </div>
                        </div>
                      </div>
                    </form>


                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                      (click)="closeModel()">Close</button>
                    <button type="button" class="btn btn-primary" (click)="submitForm()">Save</button>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">

            <table class="table table-bordered" style="min-width:768px">
              <thead>
                <tr class="texture font-size-12">
                  <th rowspan="2" class="text-center" style="width: 1%">S.No.</th>
                  <th rowspan="2">Month</th>
                  <th rowspan="2">Court/ Police</th>
                  <th colspan="2" class="text-center">Overdue at the beginning of month</th>
                  <th colspan="2" class="text-center">Fresh Cases during the Month</th>
                  <th colspan="2" class="text-center">Cases Decided during the Month</th>
                  <th colspan="2" class="text-center">Balance at the end of the Month</th>
                  <th rowspan="2" style="text-align: center; width:3%">Action</th>
                </tr>

                <tr class="texture font-size-12">
                  <th class="text-right" style="width: 6%">No.</th>
                  <th class="text-right" style="width: 11%">Amt <br>(in ₹)</th>
                  <th class="text-right" style="width: 6%">No.</th>
                  <th class="text-right" style="width: 11%">Amt <br>(in ₹)</th>
                  <th class="text-right" style="width: 6%">No.</th>
                  <th class="text-right" style="width: 11%">Amt <br>(in ₹)</th>
                  <th class="text-right" style="width: 6%">No.</th>
                  <th class="text-right" style="width: 11%">Amt <br>(in ₹)</th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let row of inspectionData; let i = index">
                  <!-- Court Row -->
                  <tr>
                    <td rowspan="2" class="text-right">{{ i + 1 }}.</td>
                    <td rowspan="2">{{ getMonthName(row.dataMonth) }}, {{ row.financialYear }}</td>
                    <td>Court</td>
                    <td class="text-right">{{ row.courtPendingNo }}</td>
                    <td class="text-right">{{ row.courtPendingAmt }}</td>
                    <td class="text-right">{{ row.courtFreshNo }}</td>
                    <td class="text-right">{{ row.courtFreshAmt }}</td>
                    <td class="text-right">{{ row.courtDecidedNo }}</td>
                    <td class="text-right">{{ row.courtDecidedAmt }}</td>
                    <td class="text-right">
                      {{ (row.courtPendingNo || 0) + (row.courtFreshNo || 0) - (row.courtDecidedNo || 0) }}
                    </td>
                    <td class="text-right">
                      {{ (row.courtPendingAmt || 0) + (row.courtFreshAmt || 0) - (row.courtDecidedAmt || 0) }}
                    </td>
                    <td rowspan="2" class="text-center no-wrap">
                      <ng-container
                        *ngIf="!row.isVerified && ( this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13 ); else verifiedBlock">
                        <button type="button" class="btn btn-primary btn-sm" title="Click to Edit"
                          (click)="editRow(row)">
                          <i class="bi bi-pencil-square"></i>
                        </button>
                        <button type="button" class="btn btn-success btn-sm" title="Click to Verify"
                          *ngIf="this.UserDetails?.roleId ==13" data-bs-toggle="modal"
                          data-bs-target="#verifyConfirmModal" (click)="setDeleteIndex(row?.id)">
                          <i class="bi bi-clipboard2-check"></i>
                        </button>
                        <button type="button" class="btn btn-danger btn-sm" title="Click to Delete"
                          data-bs-toggle="modal" data-bs-target="#deleteConfirmModal" (click)="setDeleteIndex(row?.id)">
                          <i class="bi bi-trash3"></i>
                        </button>

                      </ng-container>
                      <ng-template #verifiedBlock>
                        <button type="button" class="btn btn-primary btn-sm" title="Verified">
                          <i class="bi bi-lock"></i>
                        </button>
                      </ng-template>
                    </td>
                  </tr>

                  <!-- Police Row -->
                  <tr>
                    <td>Police</td>
                    <td class="text-right">{{ row.policePendingNo }}</td>
                    <td class="text-right">{{ row.policePendingAmt }}</td>
                    <td class="text-right">{{ row.policeFreshNo }}</td>
                    <td class="text-right">{{ row.policeFreshAmt }}</td>
                    <td class="text-right">{{ row.policeDecidedNo }}</td>
                    <td class="text-right">{{ row.policeDecidedAmt }}</td>
                    <td class="text-right">
                      {{ (row.policePendingNo || 0) + (row.policeFreshNo || 0) - (row.policeDecidedNo || 0) }}
                    </td>
                    <td class="text-right">
                      {{ (row.policePendingAmt || 0) + (row.policeFreshAmt || 0) - (row.policeDecidedAmt || 0) }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <!-- Delete Confirmation Modal -->
            <div class="modal fade" id="deleteConfirmModal" tabindex="-1" aria-labelledby="deleteConfirmModalLabel"
              aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                  </div>
                  <div class="modal-body">
                    Are you sure you want to delete?
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                      (click)="cancelDelete()">Cancel</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" aria-label="Close"
                      (click)="DeleteMisappropriation(deleteIndex)">Delete</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- verify Confirmation Modal -->
            <div class="modal fade" id="verifyConfirmModal" tabindex="-1" aria-labelledby="verifyConfirmModalLabel"
              aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                  </div>
                  <div class="modal-body">
                    Are you sure you want to Verify?
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                      (click)="this.deleteIndex = 0;">Cancel</button>
                    <button type="button" class="btn btn-success" data-bs-dismiss="modal" aria-label="Close"
                      (click)="verifyMisappropriation(deleteIndex)">Verify</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
</div>